import type { ProcessType } from '@frontend/api';
import type { CascaderPositioningOptions } from '@frontend/components';

import MaterialSelector from 'modules/common/forms/materialSelector/MaterialSelector';
import ProcessMaterialSelector from 'modules/common/forms/materialSelector/ProcessMaterialSelector';
import type { MaterialSelectorChangeHandler } from 'modules/common/forms/materialSelector/types';

type MaterialSelectProps = {
  disabled: boolean;
  menuPortalDestinationRef: React.RefObject<HTMLDivElement>;
  onChange: MaterialSelectorChangeHandler;
  process?: ProcessType | null;
  selectedMaterialId: number | null;
  selectedSupplierMaterialId: number | null;
  searchModePositioning?: CascaderPositioningOptions;
  menuModePositioning?: CascaderPositioningOptions;
};

const MaterialSelect = ({
  disabled,
  menuPortalDestinationRef,
  onChange,
  process,
  selectedMaterialId,
  selectedSupplierMaterialId,
  searchModePositioning,
  menuModePositioning,
}: MaterialSelectProps) =>
  !process || process.useGlobalMaterials ? (
    <MaterialSelector
      disabled={disabled}
      materialId={selectedMaterialId}
      onChange={onChange}
      placeholder="Select Material"
      supplierMaterialId={selectedSupplierMaterialId}
      searchModePositioning={searchModePositioning}
      menuModePositioning={menuModePositioning}
    />
  ) : (
    <ProcessMaterialSelector
      disabled={disabled}
      menuPortalDestinationRef={menuPortalDestinationRef}
      onChange={onChange}
      process={process}
      placeholder="Select Material"
      selectedMaterialId={selectedMaterialId}
      selectedSupplierMaterialId={selectedSupplierMaterialId}
    />
  );

export default MaterialSelect;
